/* eslint-disable no-unused-vars */
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import Recipe from "./Recipe";
import Resume from "./Resume";
import { useCheckoutStore } from "../../store/useCheckoutStore";
import {
  formatCurrency,
  getConfectioneryDetail,
  getTotalsRecipe,
} from "../../utils/confectioneryManager";
import { useVizionarioStore } from "../../store/useVizionarioStore";

export default function ConfectioneryProductModal({
  modalOpen,
  onCloseModal,
  currentProduct,
  currentProductApi,
  setShowCheckout,
}) {
  const [recipeProducts, setRecipeProducts] = useState([]);
  const [pricipalProduct, setPrincipalProduct] = useState(null);
  const {
    confectioneries_api,
    addConfectioneryCombo,
    bookingDetails: { location },
  } = useCheckoutStore();
  const isVizionario = useVizionarioStore((state) => state.isVizionario);

  useEffect(() => {
    if (modalOpen === false) {
      setRecipeProducts([]);
    }
    if (modalOpen === true) {
      let recipes = [];

      if (currentProduct.Tipo === "P") {
        recipes.push(currentProduct);
      } else {
        currentProduct.Receta.forEach((recipe) => {
          if (recipe.Tipo === "P") {
            recipes.push(recipe);
          } else {
            const currentProduct = recipe.Receta[0];
            const data = {
              Codigo: recipe.Codigo,
              Descripcion: recipe.Descripcion,
              Tipo: recipe.Tipo,
            };
            if (recipe.Cantidad) {
              const products = [];
              for (let i = 0; i < recipe.Cantidad; i++) {
                products.push(currentProduct);
              }
              data.Cantidad = recipe.Cantidad;
              data.Receta = products;
            } else {
              data.Receta = [currentProduct];
            }
            recipes.push(data);
          }
        });
      }

      setRecipeProducts(recipes);
    }

    return () => {};
  }, [currentProduct, modalOpen]);

  const onSelectRecipeProducts = (recipe) => {
    const recipes = recipeProducts.filter(
      (item) => item.Codigo !== recipe.Codigo
    );
    recipes.push(recipe);

    setRecipeProducts(recipes);
  };

  const onSelectProduct = () => {
    if (
      currentProduct.Receta &&
      currentProduct.Receta.length !== recipeProducts.length
    ) {
      alert("Debes seleccionar la receta del combo");
      return;
    }
    const product = {
      Codigo: currentProduct.Codigo,
      Descripcion: currentProduct.Descripcion,
      Tipo: currentProduct.Tipo,
      Cantidad: 1,
      Receta: recipeProducts,
    };
    addConfectioneryCombo(product);
    onCloseModal(false);
    setShowCheckout(true);
  };

  const renderResume = (recipe) => {
    let text = "";
    recipe.forEach((item, index) => {
      let recipeApi = {};
      if (item?.Receta) {
        recipeApi = getConfectioneryDetail(
          item?.Receta[0].Codigo,
          confectioneries_api
        );
      } else {
        recipeApi = getConfectioneryDetail(item?.Codigo, confectioneries_api);
      }
      if (recipeApi) {
        const productName = recipeApi.category_name
          ? recipeApi.category_name
          : recipeApi.name;
        text = `${text}${index > 0 && index < recipe.length ? " + " : ""}${
          item.Cantidad
        } ${productName}`;
      }
    });

    return text;
  };

  const renderTotal = () => {
    const { totalGeneral, totalOthers, saving } =
      getTotalsRecipe(recipeProducts);
    return (
      <Box
        sx={{
          border: "2px solid white",
          bgcolor: "primary.main",
          color: "white",
          p: 1,
          borderRadius: "15px",
          flex: 1,
          textAlign: "center",
          flexDirection: "column",
        }}
      >
        <Typography
          sx={{
            borderBottom: "1px solid white",
            marginBottom: "5px",
            paddingBottom: "5px",
            fontFamily: "var(--bold)",
          }}
        >
          Valor del combo{" "}
          {isVizionario
            ? formatCurrency(totalOthers)
            : formatCurrency(totalGeneral)}
        </Typography>

        <Typography sx={{ fontSize: "12px" }}>
          {isVizionario ? (
            <>
              Por ser <strong>Club Vizionarios</strong> ahorraste
            </>
          ) : (
            <>
              Por ser <strong>Club Vizionarios</strong> te habrías ahorrado
            </>
          )}{" "}
          <strong>{formatCurrency(saving)}</strong>
        </Typography>
      </Box>
    );
  };
  return (
    <Dialog
      open={modalOpen}
      onClose={onCloseModal}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          p: 0,
          borderRadius: "10px",
          background: (theme) =>
            `linear-gradient(to bottom, ${theme.palette.secondary.main}, black, ${theme.palette.secondary.main})`,
          color: "primary.contrastText",
        },
      }}
    >
      {/* Cuerpo del modal */}
      <DialogContent dividers sx={{ padding: "0px", borderRadius: "10px" }}>
        {/* Encabezado con imagen y nombre */}
        <DialogTitle sx={{ p: 0, position: "relative" }}>
          <Box
            component="img"
            src={
              currentProductApi.image
                ? currentProductApi.image
                : "/src/assets/images/product-fallback.png"
            }
            alt={currentProduct.Descripcion}
            sx={{
              width: "100%",
              height: "15vh",
              objectFit: "cover",
              objectPosition: "center",
              borderRadius: "10px",
              mb: "-10px",
              maskImage:
                "linear-gradient(to bottom, black 40%, transparent 100%)",
              WebkitMaskImage:
                "linear-gradient(to bottom, black 40%, transparent 100%)",
            }}
          />
          <Box
            sx={{
              backgroundColor: "inherit",
              p: "0px 24px",
              textAlign: "left",
            }}
          >
            <Typography
              variant="h6"
              sx={{ color: "white", fontFamily: "var(--bold)" }}
            >
              {currentProduct?.name || currentProduct?.Descripcion}
            </Typography>
            {currentProduct.Receta && (
              <Box>
                <Typography variant="subtitle1" sx={{ color: "white" }}>
                  Incluye:
                </Typography>
                <Typography variant="subtitle2" sx={{ color: "white" }}>
                  {renderResume(currentProduct.Receta)}
                </Typography>
              </Box>
            )}
          </Box>
          <IconButton
            onClick={onCloseModal}
            sx={{
              position: "absolute",
              top: 0,
              right: 0,
              backgroundColor: "inherit",
              color: "white",
              border: "2px solid white",
              p: 0,
              m: "20px 25px",
              "&:hover": {
                backgroundColor: "white",
                color: "secondary.main",
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <Typography variant="body1" align="left" sx={{ mt: 1, px: "20px" }}>
          Personaliza tu combo
        </Typography>
        <Box
          sx={{
            textAlign: "left",
            p: 0,
            fontSize: "12px",
            mb: "20px",
            px: "20px",
          }}
          dangerouslySetInnerHTML={{
            __html:
              "Los productos con (*) cambian el precio del combo, lo puedes validar en la parte inferior en 'Valor del combo'",
          }}
        />
        {currentProduct.Receta ? (
          currentProduct.Receta.map((recipe) => {
            return (
              <Recipe
                recipe={recipe}
                key={recipe.Codigo}
                onSelectRecipeProducts={onSelectRecipeProducts}
                recipeProducts={recipeProducts}
                principalProduct={currentProductApi}
              />
            );
          })
        ) : (
          <Recipe
            recipe={currentProduct}
            key={currentProduct.Codigo}
            onSelectRecipeProducts={onSelectRecipeProducts}
            recipeProducts={recipeProducts}
            principalProduct={currentProductApi}
          />
        )}
      </DialogContent>

      {/* Footer con resumen y totales */}
      <DialogActions
        sx={{
          p: "16px 24px",
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          borderTop: "1px solid",
          borderTopColor: "primary.main",
        }}
      >
        <Resume recipe={recipeProducts} productApi={currentProductApi} />

        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            backgroundColor: "inherit",
            borderRadius: "20px",
            gap: "15px",
          }}
        >
          {renderTotal()}

          <Button
            onClick={onSelectProduct}
            fullWidth
            variant="outlined"
            sx={{
              border: "2px solid white",
              color: "white",
              p: 1,
              borderRadius: "15px",
              flex: 1,
              textAlign: "center",
            }}
          >
            AGREGAR AL CARRITO
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
}

ConfectioneryProductModal.propTypes = {
  modalOpen: PropTypes.bool,
  onCloseModal: PropTypes.func,
  setShowCheckout: PropTypes.func,
  currentProduct: PropTypes.object,
  currentProductApi: PropTypes.object,
};
